import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { WorkshopListDT } from "../../components/DataTables/WorkshopListDT";

export const Workshops = () => {
  const navigate = useNavigate();

  return (
    <div className="p-card gap-4 p-3">
      <div className="flex w-full justify-content-center align-items-center gap-3 mt-4 mb-6">
        <h1 className="text-center">Talleres</h1>
        <Button
          icon="pi pi-plus"
          rounded
          aria-label="Crear taller"
          size="small"
          onClick={() => navigate("new")}
        />
        <Button
          icon="pi pi-sort-alt"
          rounded
          outlined
          aria-label="Reordenar talleres"
          size="small"
          tooltip="Reordenar talleres"
          tooltipOptions={{ position: "top" }}
          onClick={() => navigate("sort-order")}
        />
      </div>
      <WorkshopListDT />
    </div>
  );
};
